"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var createCacheAsyncAction = function createCacheAsyncAction(asyncFn, existValue) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return function (dispatch, getState) {
      if (existValue.apply(void 0, [getState()].concat(args))) {
        return Promise.resolve([].concat(args));
      } else {
        var asyncActionPromise = dispatch(asyncFn.apply(void 0, args));

        if (asyncActionPromise instanceof Promise) {
          return asyncActionPromise.then(function (res) {
            return [].concat(args, [res]);
          });
        } else {
          // asyncActionPromise is actually not promise, but value, so we just call onComplete with its value
          return Promise.resolve([].concat(args, [asyncActionPromise]));
        }
      }
    };
  };
};

var _default = createCacheAsyncAction;
exports["default"] = _default;